import { FaWallet } from "react-icons/fa";

export function WalletDashboardHeader() {
  return (
    <div className="flex items-center gap-3">
      <div className="w-12 h-12 rounded-lg bg-[#1E61DC]/10 flex items-center justify-center">
        <FaWallet className="w-6 h-6 text-[#1E61DC]" />
      </div>
      <div>
        <span className="text-[#1A1A1A] text-xl">Wallet Revenue Dashboard</span>
        <p className="text-[#6B7280]">
          Digital wallet balances, transactions, and credit management
        </p>
      </div>
    </div>
  );
}
